/**
 * Health Check Timing Configuration
 */
export const INACTIVITY_THRESHOLD = Infinity; // Disabled - no timeout
export const INACTIVITY_THRESHOLD_IN_SECONDS = Infinity; // Disabled - no timeout
export const TIME_BEFORE_TIMEOUT = 30000; // 30 seconds
export const HEALTH_CHECK_INTERVAL = 10000; // 10 seconds
export const MAX_CRASH_COUNT = 3;

/**
 * Error Tracking Configuration
 */
export const ERROR_TRACKING_CONFIG = {
  MAX_ERROR_MESSAGES: 10,
  CONSECUTIVE_ERROR_THRESHOLD: 3,
} as const;

/**
 * Error Type-Specific Crash Count Limits
 */
export const ERROR_TYPE_LIMITS = {
  BROWSER: 1,
  AVATAR_SERVICE: 2,
  NETWORK: MAX_CRASH_COUNT,
  DEFAULT: MAX_CRASH_COUNT,
} as const;

/**
 * Error Type-Specific Thresholds for Health Checks
 */
export const ERROR_TYPE_THRESHOLDS = {
  NETWORK_ERRORS: 5,
  AVATAR_SERVICE_ERRORS: 3,
} as const;

/**
 * Error Type Constants
 */
export const ERROR_TYPES = {
  BROWSER: "browser",
  AVATAR_SERVICE: "avatar_service",
  NETWORK: "network",
  TIMEOUT: "timeout",
  UNKNOWN: "unknown",
} as const;

/**
 * Health Monitor Event Names
 */
export const HEALTH_MONITOR_EVENTS = {
  AVATAR_HEALTH_CRASH: "avatar_health_crash",
  AVATAR_IDLE_WARNING: "avatar_idle_warning",
  AVATAR_ERROR: "avatar_error",
  AVATAR_ACTIVITY: "avatar_activity",
} as const;
